import React from 'react';
import NewItemBadge from './NewItemBadge.jsx';
import UserEntityBadge from './UserEntityBadge.jsx';

const badgeMap = {
  newItem: NewItemBadge,
  userEntity: UserEntityBadge,
};

const BadgeWrapper = ({ position, badge, text }) => {
  const BadgeComponent = badgeMap[badge];

  if (position === 'before') {
    return (
      <React.Fragment>
        <BadgeComponent position={position} />
        {text}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {text}
      <BadgeComponent position={position} />
    </React.Fragment>
  );
};

export default BadgeWrapper;
